// This file was auto-generated by Fern from our API Definition.
export const ChannelSecretKind = {
    Slack: "slack",
    Telegram: "telegram",
    Whatsapp: "whatsapp",
    Agenta: "agenta",
    Bridge: "bridge",
};
